// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BalanceBasedAddCashSettingsEditEvent
 */
export var BalanceBasedAddCashSettingsEdit = function (_a) {
    var option = _a.option;
    return ({
        name: "BalanceBasedAddCash Settings Edit",
        parameters: {
            cdf_entity: "BalanceBasedAddCash",
            cdf_action: "Settings",
            option: option !== undefined && option !== null ? option.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BalanceBasedAddCashEditAmountViewedEvent
 */
export var BalanceBasedAddCashEditAmountViewed = function (_a) {
    var option = _a.option, method = _a.method, flowToken = _a.flowToken;
    return ({
        name: "BalanceBasedAddCash EditAmount Viewed",
        parameters: {
            cdf_entity: "BalanceBasedAddCash",
            cdf_action: "EditAmount",
            option: option !== undefined && option !== null ? option.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            method: method !== undefined && method !== null ? method.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BalanceBasedAddCashEditAmountInvalidEvent
 */
export var BalanceBasedAddCashEditAmountInvalid = function (_a) {
    var option = _a.option, flowToken = _a.flowToken;
    return ({
        name: "BalanceBasedAddCash EditAmount Invalid",
        parameters: {
            cdf_entity: "BalanceBasedAddCash",
            cdf_action: "EditAmount",
            option: option !== undefined && option !== null ? option.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BalanceBasedAddCashEditAmountExpandEvent
 */
export var BalanceBasedAddCashEditAmountExpand = function (_a) {
    var option = _a.option, flowToken = _a.flowToken;
    return ({
        name: "BalanceBasedAddCash EditAmount Expand",
        parameters: {
            cdf_entity: "BalanceBasedAddCash",
            cdf_action: "EditAmount",
            option: option !== undefined && option !== null ? option.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BalanceBasedAddCashEditAmountSaveEvent
 */
export var BalanceBasedAddCashEditAmountSave = function (_a) {
    var option = _a.option, method = _a.method, amount = _a.amount, flowToken = _a.flowToken;
    return ({
        name: "BalanceBasedAddCash EditAmount Save",
        parameters: {
            cdf_entity: "BalanceBasedAddCash",
            cdf_action: "EditAmount",
            option: option !== undefined && option !== null ? option.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            method: method !== undefined && method !== null ? method.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BalanceBasedAddCashEditAmountCloseEvent
 */
export var BalanceBasedAddCashEditAmountClose = function (_a) {
    var option = _a.option, method = _a.method, amount = _a.amount, flowToken = _a.flowToken;
    return ({
        name: "BalanceBasedAddCash EditAmount Close",
        parameters: {
            cdf_entity: "BalanceBasedAddCash",
            cdf_action: "EditAmount",
            option: option !== undefined && option !== null ? option.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            method: method !== undefined && method !== null ? method.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
